import type { BrandingConfig, LogoConfig } from 'config-types/config/branding';

const BRANDING_DATA: BrandingConfig = {
  projectName: 'Quality Urgent Care',
  projectDomain: 'www.qualityurgentcareofamerica.com',
  email: {
    logoURL:
      'http://cdn.mcauto-images-production.sendgrid.net/978880ba6bbd1598/6e243438-0d24-4b2e-9604-0c6671c52964/419x190.png',
    palette: {
      deemphasizedText: '#00000061',
      headerText: '#0F347C',
      bodyText: '#000000DE',
      footerText: '#212130',
      buttonColor: '#3D89E3',
    },
    sender: 'noreply@qualityurgentcare.com',
    replyTo: 'noreply@qualityurgentcare.com',
  },
  logo: {
    default: '',
    email: '',
    pdf: '',
  },
  intake: {
    primaryIconAlt: 'Ottehr icon',
    appBar: {
      backgroundColor: '#FFF',
      logoHeight: '52px',
      logoutButtonTextColor: '#3D89E3',
    },
    assets: {
      logo: '/intakeLogo.png',
      primaryIcon: '/primaryIcon.svg',
    },
    theme: {
      otherColors: {
        appBarBackground: '#FFFFFF',
      },
      palette: {
        primary: {
          light: '#3D89E3',
        },
        secondary: {
          main: '#3D89E3',
        },
        background: {
          default: '#F7F7F7',
        },
      },
    },
  },
};

export const BRANDING_CONFIG = Object.freeze(BRANDING_DATA);

// Derived constant - defined here to avoid circular dependencies
// (types/constants.ts cannot import from ottehr-config without creating a cycle)
export const PROJECT_WEBSITE = `https://${BRANDING_CONFIG.projectDomain}`;

type LogoTarget = Exclude<keyof LogoConfig, 'default'>;

export function getLogoFor(target: LogoTarget): string | undefined {
  const { logo } = BRANDING_CONFIG;

  return logo?.[target] || logo?.default;
}
